import $ from './jq';
import {playList,weiIndex,wuIndex,shuIndex,qunIndex,wei,shu,qun,wu} from './conf';
import {events} from './events'
export const state = {
  account: '',
  isLogin: false,
  isPhone: false,
};
function initYoutubeVideo(index) {
  $('.j-video-wrapper').html(
    `<iframe width="100%" height="100%" src="https://www.youtube.com/embed/${playList[index]}?rel=0&playsinline=1&showinfo=0&disablekb=1&autoplay=1&modestbranding=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
  );
};

function clearYoutubeVideo() {
  $('.j-video-wrapper').html('');
}
function toggleMusic() {
  if (events.isPlaying) {
    $('.j-music-audio')[0].pause();
    $('.j-music-btn').html('OFF');
    events.isPlaying = false;
  } else {
    $('.j-music-audio')[0].play();
    $('.j-music-btn').html('ON');
    events.isPlaying = true;
  }
}
const bindEvent = function () {
  $('.j-nav-close-btn').on('click', function () {
    $('.nav-wrap').removeClass('nav-show');
  });

  $('.j-menu-btn').on('click', function () {
    $('.nav-wrap').addClass('nav-show');
  });

  $('.j-menu-close').on('click', function () {
    $('.j-menu-wrap').fadeOut();
  });

  $('.j-menu-open').on('click', function () {
    $('.j-menu-wrap').fadeIn();
  });

  $('.j-popup-text-bg,.j-popup-text-close').on('click', function () {
    $('#j-popup-tip').fadeOut();
  });
/*  $('.j-startGame').on('click',function () {
    alert('敬請期待');
  })*/
  const $musicBtn = $('.j-music-btn');
  $('body').on('click', '.j-play-video', function ({target}) {
    if (!target.dataset.video) {
        return;
    }
    const index = ~~target.dataset.video;
    $musicBtn.length && events.isPlaying && toggleMusic();
    initYoutubeVideo(index);
    $('.j-video').fadeIn('normal', function () {
      $('body').css({ overflow: 'hidden' });
    });
  });
  $('.j-video').on('click',function () {
    $('.j-video').fadeOut('normal', () => {
      $('body').css({ overflow: 'auto' });
      $musicBtn.length && events.userPlayState && toggleMusic();
      clearYoutubeVideo();
    })
  })
/*  $('body').on('click', '.j-video', function () {  // 在iphone xs max不生效
    $('.j-video').fadeOut('normal', () => {
      $('body').css({ overflow: 'auto' });
      $musicBtn.length && events.userPlayState && toggleMusic();
      clearYoutubeVideo();
    });
  });*/
};

const swiperInit = function () {
  let featureSwiper = new Swiper('.feature-swiper', {
    effect: 'coverflow',
    slidesPerView: 2,
    autoplay: true,
    centeredSlides: true,
    coverflowEffect: {
      rotate: 0,
      stretch: -30,
      depth: 200,
      modifier: 1,
      slideShadows: false,
    },
    loop: true,
    observer: true,
    observeParents: true,
    pagination: {
      el: '.feature-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.j-feature-next',
      prevEl: '.j-feature-prev',
    },
  });
  let videoSwiper = new Swiper('.video-swiper', {
    loop: true,
    autoplay: true,
    observer: true,
    observeParents: true,
    pagination: {
      el: '.video-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.j-video-next',
      prevEl: '.j-video-prev',
    },
  });
  let countrySwiper = new Swiper('.country-swiper', {
    loop: true,
    autoplay: false,
    speed: 1000,
    observer: true,
    observeParents: true,
    noSwiping: true,
    pagination: {
      el: '.country-pagination',
      clickable: true,
      type: 'custom',
      renderCustom: function (swiper, current, total) {
        let html = '';
        let country = ['qun', 'wei', 'shu', 'wu'];
        for (let i = 0; i < total; i++) {
          html += `<a href="javascript:;" class="j-country-btn swiper-pagination-bullet ${
            i + 1 == current
              ? 'swiper-pagination-bullet-active active-country'
              : ''
          } ${country[i]}" data-index="${i + 1}"></a>`;
        }
        return html;
      },
    },
  });
  let weiSwiper = new Swiper('.wei-swiper', {
    loop: true,
    autoplay: false,
    observer: true,
    observeParents: true,
    speed: 1000,
    pagination: {
      el: '.wei-pagination',
      clickable: true,
      type: 'custom',
      renderCustom: function (swiper, current, total) {
        let html = '';
        for (let i = 0; i < total; i++) {
          html += `<a href="javascript:;" class="char j-hero-btn swiper-pagination-bullet ${
            i + 1 == current
              ? 'swiper-pagination-bullet-active active-hero'
              : ''
          } ${weiIndex[i]}-s" data-index="${i + 1}"></a>`;
        }
        return html;
      },
    },
    on: {
      init: function () {
        changeMsg('wei', wei[weiIndex[0]]);
      },
      slideChange: function () {
        changeMsg('wei', wei[weiIndex[this.activeIndex - 1]]);
      },
    },
  });
  let shuSwiper = new Swiper('.shu-swiper', {
    loop: true,
    autoplay: false,
    observer: true,
    observeParents: true,
    speed: 1000,
    pagination: {
      el: '.shu-pagination',
      clickable: true,
      type: 'custom',
      renderCustom: function (swiper, current, total) {
        let html = '';
        for (let i = 0; i < total; i++) {
          html += `<a href="javascript:;" class="char j-hero-btn swiper-pagination-bullet ${
            i + 1 == current
              ? 'swiper-pagination-bullet-active active-hero'
              : ''
          } ${shuIndex[i]}-s" data-index="${i + 1}"></a>`;
        }
        return html;
      },
    },
    on: {
      init: function () {
        changeMsg('shu', shu[shuIndex[0]]);
      },
      slideChange: function () {
        changeMsg('shu', shu[shuIndex[this.activeIndex - 1]]);
      },
    },
  });
  let wuSwiper = new Swiper('.wu-swiper', {
    loop: true,
    autoplay: false,
    observer: true,
    observeParents: true,
    speed: 1000,
    pagination: {
      el: '.wu-pagination',
      clickable: true,
      type: 'custom',
      renderCustom: function (swiper, current, total) {
        let html = '';
        for (let i = 0; i < total; i++) {
          html += `<a href="javascript:;" class="char j-hero-btn swiper-pagination-bullet ${
            i + 1 == current
              ? 'swiper-pagination-bullet-active active-hero'
              : ''
          } ${wuIndex[i]}-s" data-index="${i + 1}"></a>`;
        }
        return html;
      },
    },
    on: {
      init: function () {
        changeMsg('wu', wu[wuIndex[0]]);
      },
      slideChange: function () {
        changeMsg('wu', wu[wuIndex[this.activeIndex - 1]]);
      },
    },
  });
  let qunSwiper = new Swiper('.qun-swiper', {
    loop: true,
    autoplay: false,
    observer: true,
    observeParents: true,
    speed: 1000,
    pagination: {
      el: '.qun-pagination',
      clickable: true,
      type: 'custom',
      renderCustom: function (swiper, current, total) {
        let html = '';
        for (let i = 0; i < total; i++) {
          html += `<a href="javascript:;" class="char j-hero-btn swiper-pagination-bullet ${
            i + 1 == current
              ? 'swiper-pagination-bullet-active active-hero'
              : ''
          } ${qunIndex[i]}-s" data-index="${i + 1}"></a>`;
        }
        return html;
      },
    },
    on: {
      init: function () {
        changeMsg('qun', qun[qunIndex[0]]);
      },
      slideChange: function () {
        changeMsg('qun', qun[qunIndex[this.activeIndex - 1]]);
      },
    },
  });
};
const changeMsg = (country, { charDesc }) => {
  charDesc && $(`.${country} .j-char-desc`).html(charDesc);
};

export const init = function () {
  swiperInit();
  bindEvent();
};
